/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGantt = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M18.5 4h-13C4 4 4 5.5 4 5.5v13C4 20 5.5 20 5.5 20h13s1.5 0 1.5-1.5v-13C20 4 18.5 4 18.5 4M12 17H6v-2h6v2m3-4H9v-2h6v2m3-4h-6V7h6v2" /></svg>;
export default SvgGantt;